var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2480.000000pt",
    height: "3508.000000pt",
    viewBox: "0 0 2480.000000 3508.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,3508.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11995 28214 c-1918 -79 -3734 -645 -5328 -1661 -2661 -1695 -4440 -4478 -4852 -7588 -70 -531 -89 -830 -89 -1420 0 -590 19 -889 89 -1420 253 -1911 1028 -3726 2234 -5235 1727 -2160 4206 -3565 6926 -3925 531 -70 830 -89 1420 -89 590 0 889 19 1420 89 2720 360 5199 1765 6926 3925 1206 1509 1981 3324 2234 5235 70 531 89 830 89 1420 0 590 -19 889 -89 1420 -450 3398 -2519 6374 -5565 8005 -1313 703 -2743 1112 -4290 1225 -195 15 -930 27 -1125 19z m3580 -7019 c215 -38 388 -127 540 -280 132 -131 216 -277 267 -463 31 -112 31 -382 0 -494 -93 -340 -334 -598 -659 -707 -160 -54 16 -51 -3318 -51 -2715 0 -3093 2 -3170 15 -215 38 -388 127 -540 280 -132 131 -216 277 -267 463 -31 112 -31 382 0 494 51 186 135 332 267 463 115 116 240 193 392 244 154 52 -8 49 3309 50 2726 1 3102 -1 3179 -14z m-30 -5300 c215 -38 388 -127 540 -280 132 -131 216 -277 267 -463 31 -112 31 -382 0 -494 -93 -340 -334 -598 -659 -707 -160 -54 16 -51 -3318 -51 -2715 0 -3093 2 -3170 15 -215 38 -388 127 -540 280 -132 131 -216 277 -267 463 -31 112 -31 382 0 494 51 186 135 332 267 463 115 116 240 193 392 244 154 52 -8 49 3309 50 2726 1 3102 -1 3179 -14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquals);
export default __webpack_public_path__ + "static/media/equals.d585fc2436f96f11b9113aa3d34aa0aa.svg";
export { ForwardRef as ReactComponent };